import { render, staticRenderFns } from "./preferedCard.vue?vue&type=template&id=6bcb8b28&scoped=true&"
import script from "./preferedCard.vue?vue&type=script&lang=js&"
export * from "./preferedCard.vue?vue&type=script&lang=js&"
import style0 from "./preferedCard.vue?vue&type=style&index=0&id=6bcb8b28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcb8b28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bcb8b28')) {
      api.createRecord('6bcb8b28', component.options)
    } else {
      api.reload('6bcb8b28', component.options)
    }
    module.hot.accept("./preferedCard.vue?vue&type=template&id=6bcb8b28&scoped=true&", function () {
      api.rerender('6bcb8b28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/profile/startupProfile/preferedCard.vue"
export default component.exports